import React, { PureComponent } from 'react';
import {
  FaFortAwesome,
  FaHistory,
  FaMobileAlt,
  FaUser,
  FaYenSign
} from 'react-icons/fa';
import { Translate }               from 'react-localize-redux';
import { connect }                 from 'react-redux';
import { firebaseConnect, getVal } from 'react-redux-firebase';
import { compose }                 from 'redux';
import styled                      from 'styled-components';
import Heading, { SubHeading }     from '../../../components/heading';
import Indicator                   from '../../../components/indicator';
import formatCurrency              from '../../../utilities/format-currency';
import { InformationHeading }      from '../heading';
import ImgFrame                    from '../images/popup_bg.png';
import Section                     from '../section';
import titleImg                    from '../images/title/Information.png';

const Container = styled.div`
  color: #ffffff;
`;

const Table = styled.div`
  align-items          : center;
  display              : grid;
  grid-gap             : 0 1.2em;
  grid-template-columns: auto 1fr;
  margin               : 1em auto 1em;
  padding              : 3em 2em 3em 2em;
  width                : 60vw;
  height               : 60vw;
  max-width            : 768px;
  max-height           : 768px;

  background-repeat    : no-repeat;
  background-size      : contain;
  background-position  : center center;
  background-image     : url(${ImgFrame});

`;

const TableLabel = styled.div`
  align-items: center;
  background : black;
  color      : ${props => props.theme.primary};
  border     : solid 3px ${props => props.theme.primary};
  display    : flex;
  margin     : 0.6em 0;
  padding    : 0.6em 1.2em;

  > *:first-child {
    margin-right: 0.4em;
  }

  @media (max-width: 1260px) { font-size: 1.7vw; }
  @media (max-width:  562px) { font-size: 1.5vw; }
  @media (max-width:  538px) { font-size: 1.3vw; }
`;

const TableValue = styled.div`
  line-height: 1.5;
  color: #000;

  @media (max-width: 1260px) { font-size: 1.7vw; }
  @media (max-width:  562px) { font-size: 1.5vw; }
  @media (max-width:  538px) { font-size: 1.3vw; }
`;

/**
 * Information section
 */
class Information extends PureComponent {
  render() {
    const { game } = this.props;

    return (
      <Container>
        <Section imgSrc={titleImg} >

        {!game && <Indicator spin />}
        {game && (
          <>
            <Table>
              <TableLabel>
                <FaHistory />
                <Translate id="cmpLandingPage.information.timeLimit" />
              </TableLabel>
              <TableValue>
                <div>
                  {game.timeLimit}
                  <Translate id="cmpLandingPage.information.minute" />
                </div>
              </TableValue>
              <TableLabel>
                <FaHistory />
                <Translate id="cmpLandingPage.information.playTime" />
              </TableLabel>
              <TableValue>
                <div>
                  {game.gameDuration}
                  <Translate id="cmpLandingPage.information.notice" />
                </div>
              </TableValue>

              <TableLabel>
                <FaUser />
                <Translate id="cmpLandingPage.information.playerCapacity" />
              </TableLabel>
              <TableValue>
                <Translate id="cmpLandingPage.information.noPlayerLimit" />
              </TableValue>
              <TableLabel>
                <FaYenSign />
                <Translate id="cmpLandingPage.information.price" />
              </TableLabel>
              <TableValue>
                <span>
                  <Translate id="cmpLandingPage.information.weekday" /> &yen;
                  {formatCurrency(game.weekdayPrice)}
                </span>
                <span>
                  <Translate id="cmpLandingPage.information.continue" />
                </span>

              </TableValue>
              <TableLabel>
                <FaMobileAlt />
                <Translate id="cmpLandingPage.information.belongings.label" />
              </TableLabel>
              <TableValue>
                <Translate id="cmpLandingPage.information.belongings.value" />
              </TableValue>
              <TableLabel>
                <FaFortAwesome />
                <Translate id="cmpLandingPage.information.location.label" />
              </TableLabel>
              <TableValue>
                <span>
                  <Translate id="cmpLandingPage.information.location.warning" />
                </span>
                <br/>
                <span>
                  <Translate id="cmpLandingPage.information.location.warning2" />
                </span>
                <br/>
                <span>
                  <Translate id="cmpLandingPage.information.location.warning3" />
                </span>
              </TableValue>
            </Table>

          </>
        )}
      </Section>
    </Container>
    );
  }
}

/**
 * Map Redux State to props
 */
const mapStateToProps = ({ global, firebase }) => {
  const gameId = global.gameId;
  return {
    gameId,
    game: getVal(firebase.data, `games/${gameId}`),
    databaseLoaded: global.loadedResources.database
  };
};

export default compose(
  connect(mapStateToProps, null),
  firebaseConnect(({ gameId, databaseLoaded }) => {
    // Check for database loaded
    if (!databaseLoaded) {
      return;
    }
    return [`games/${gameId}`];
  })
)(Information);
